import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'app-add-candidates-page',
  templateUrl: './add-candidates-page.component.html'
})
export class AddCandidatesPageComponent implements OnInit {

  @Input() $transition$: any;

  $stateParams: any;

  constructor(
    public $state: StateService
  ) { }

  ngOnInit() {
    this.$stateParams = this.$transition$.params();
  }

  saveCallback(): void {
    this.$state.go('missioncontrol.candidates');
  }
}
